<template>
    <div class='filters'>
        <div class='container'>
            <div class='filters__row row offset--md-4 offset--lg-3'>

                <div class='filters__filter col--sm-expand col--md-third gutter--md'>
                    <div class='filters__selected' :class='{ "state-active": selectedIndustry }'>
                        <a class='filters__button' @click.prevent='toggle(1)' @mouseenter='enter(1)' @mouseleave='leave(1)'>
                            <span class='show-for-sr'>Selected: </span>{{ (selectedIndustry) ? selectedIndustry.title : industryText }}
                            <span class='filters__toggle'><span class='show-for-sr'>Toggle industry list</span></span>
                        </a>
                    </div>

                    <div class='filters__dropdown'>
                        <div class='container'>
                            <ul class='filters__list col--md-8 offset--md-4 offset--lg-3'>
                                <li class='col--sm-half col--md-third col--lg-3 gutter--small'>
                                    <a class='filters__button' :class='{ "state-active": !$route.params.industry }' @click.prevent='filter("industry"); deactivate();'>
                                        {{ allText }}
                                    </a>
                                </li>
                                <li class='col--sm-half col--md-third col--lg-3 gutter--small' v-for='industry in filters.industries'>
                                    <a class='filters__button' :class='{ "state-active": $route.params.industry === industry.slug }' @click.prevent='filter("industry", industry.slug); deactivate();'>
                                        {{ industry.title }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class='filters__filter col--sm-expand col--md-third gutter--md'>
                    <div class='filters__selected state-active'>
                        <a class='filters__button' @click.prevent='toggle(2)' @mouseenter='enter(2)' @mouseleave='leave(2)'>
                            <span class='show-for-sr'>Selected year: </span>{{ selectedYear }}
                            <span class='filters__toggle'><span class='show-for-sr'>Toggle year list</span></span>
                        </a>
                    </div>

                    <div class='filters__dropdown'>
                        <div class='container'>
                            <ul class='filters__list col--md-12 col--lg-8 offset--md-4 offset--lg-3'>
                                <li class='col--sm-half col--md-2 gutter--small' v-for='year in filters.years'>
                                    <a class='filters__button' :class='{ "state-active": parseInt($route.params.year) === year }' @click.prevent='filter("year", year); deactivate();'>
                                        {{ year }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class='filters__filter col--sm-expand col--md-third gutter--md'>
                    <div class='filters__selected state-active'>
                        <a class='filters__button' @click.prevent='toggle(3)' @mouseenter='enter(3)' @mouseleave='leave(3)'>
                            <span class='show-for-sr'>Selected region: </span>{{ (selectedRegion) ? selectedRegion.title : globalText }}
                            <span class='filters__toggle'><span class='show-for-sr'>Toggle region list</span></span>
                        </a>
                    </div>

                    <div class='filters__dropdown'>
                        <div class='container'>
                            <ul class='filters__list col--md-8 col--lg-6 offset--md-4 offset--lg-3'>
                                <li class='col--sm-half col--md-third col--lg-2 gutter--small' v-for='region in filters.regions'>
                                    <a class='filters__button' :class='{ "state-active": $route.params.region === region.slug }' @click.prevent='filter("region", region.slug); deactivate();'>
                                        {{ region.title }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

            <div class='filters__rule-container offset--md-4 offset--lg-3 gutter hide--sm'>
                <hr class='filters__rule'>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import layout from '~/js/services/layout';

export default {
    methods: {
        filter (name, slug = null) {
            if (this.loading) {
                return;
            }

            const params = {
                year: this.selectedYear
            };

            if (this.selectedRegion) {
                params.region = this.selectedRegion.slug
            }

            if (this.selectedIndustry) {
                params.industry = this.selectedIndustry.slug;
            }

            params[name] = slug;

            this.$router.push({ params });
        },

        toggle (index) {
            if (this.loading) {
                return;
            }

            if (this.$el.classList.contains(`state-filter-active-${index}`)) {
                this.deactivate();
            } else {
                this.activate(index);
            }
        },

        activate (index) {
            const $filters = $(this.$el);
            const $activeFilter = $(`.filters__filter:nth-child(${index})`);
            const $activeDropdown = $activeFilter.find('.filters__dropdown');
            const $otherDropdowns = $('.filters__filter').not($activeFilter).find('.filters__dropdown');

            if (layout.breakpointIs('PHONE')) {
                $otherDropdowns.slideUp();
                $activeDropdown.slideDown();
            } else {
                $activeDropdown.fadeIn();
                $otherDropdowns.fadeOut();
            }

            $filters.removeClass((i, classes) => {
                const matches = classes.match(/\bstate-filter-active-\S+/ig);
                return (matches) ? matches.join(' ') : '';
            });
            $filters.addClass(`state-filter-active-${index}`);

            $(document).on('click.filters', e => {
                if ($(e.target).closest($filters).length === 0) {
                    this.deactivate();
                    e.preventDefault();
                }
            });
        },

        enter (index) {
            this.$el.classList.add(`state-filter-over-${index}`);
        },

        leave (index) {
            this.$el.classList.remove(`state-filter-over-${index}`);
        },

        deactivate () {
            const $filters = $(this.$el);
            const $dropdowns = $('.filters__dropdown');

            if (layout.breakpointIs('PHONE')) {
                $dropdowns.slideUp();
            } else {
                $dropdowns.fadeOut();
            }

            $filters.removeClass((i, classes) => {
                const matches = classes.match(/\bstate-filter-\S+/ig);
                return (matches) ? matches.join(' ') : '';
            });

            $(document).off('.filters');
        }
    },

    props: [
        'loading',
        'filters',
        'selectedIndustry',
        'selectedYear',
        'selectedRegion',
        'allText',
        'industryText',
        'globalText'
    ]
}
</script>



// WEBPACK FOOTER //
// assets/js/thelist/components/Filters.vue